// extracted by mini-css-extract-plugin
export default {"actions":"ui_actions__VyAa4","wrap":"ui_wrap__lb4JS","author":"ui_author__Dyx0a","position":"ui_position__ez-XX"};